import BaseModel from './BaseModel';

export default class TourProperty extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.address = data.address || this.translate.address || undefined;
        this.email = data.email || undefined;
        this.phone = data.phone || undefined;
        this.type = data.type || []
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            address: this.address,
            email: this.email,
            phone: this.phone,
            type: this.type
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                propertyId: this.translate.propertyId || this.id,
                name: this.name,
                address: this.address,
                languageCode: this.languageCode,
                type: this.type
            }
        }
        return result;
    }
}